AuthRoute = require 'mixins/authenticated-route'

App.OrdersMapOrderRoute = Em.Route.extend AuthRoute,
  afterModel: (model)->
    restaurant = model.get('restaurant.id')

  setupController: (controller, model) ->
    @_super(arguments...)
    @controllerFor('orders.map.order').set('currentPopupOpened', '')
    @controllerFor('orders.map').set('selectedOrder', model)

  deactivate: ->
    @controllerFor('orders.map').set('selectedOrder', null)

  renderTemplate: (controller, model) ->
    @render 'orders.map.order',
      into: 'orders'
      outlet: 'popup'
      controller: controller
